import AsyncFlow from '../asyncFlow';

//utils
import { isValid, startOfToday, isBefore, isAfter, endOfYear } from 'date-fns';
import subDays from 'date-fns/subDays';
import parseISO from 'date-fns/parseISO';
import isEqual from 'lodash/isEqual';

import { validateEmail } from './../../utils/global';

const ERROR_TEXT = {
    data_scadenza: '',
    cliente: '',
    email: '',
    codice_utente: ''
};

const LICENSE_DATA = {
    hasScadenza: true,
    data_scadenza: null,
    cliente: '',
    email: '',
    codice_utente: '',
};


export default AsyncFlow({
    store: 'edit-license',
    initialState: {
        license_data: LICENSE_DATA,
        new_license_data: LICENSE_DATA,   
        isChanged: false,
        isValid: true,
        errorText: ERROR_TEXT,
        isModified: '',
        statusAction: 'READY',
    },
    actions: ['EDIT_LICENSE', 'RESET_EDIT_LICENSE_STORE', 'INITIALIZE_FIELDS', 'HANDLE_CHANGE_FIELD_NEW_DATA', 'VALIDATE_FIELD'],
}).extend({
    reducer: (state, action, { types }) => {

        var errorText_temp = state.errorText;

        switch (action.type) {
            case types.RESET_EDIT_LICENSE_STORE:
                return {
                    ...state,
                    license_data: LICENSE_DATA,
                    new_license_data: LICENSE_DATA,
                    isChanged: false,
                    isValid: true,
                    errorText: ERROR_TEXT,
                    isModified: '',
                };

            case types.INITIALIZE_FIELDS:
                const license_data_temp = {
                    hasScadenza: action.payload.data_scadenza !== null ? true : false,
                    data_scadenza: action.payload.data_scadenza !== null ? parseISO(action.payload.data_scadenza) : null,
                    cliente: action.payload.cliente !== null ? action.payload.cliente : '',
                    email: action.payload.email !== null ? action.payload.email : '',
                    codice_utente: action.payload.codice_utente !== null ? action.payload.codice_utente : '',
                };

                return {
                    ...state,
                    license_data: license_data_temp,
                    new_license_data: license_data_temp
                };

            case types.HANDLE_CHANGE_FIELD_NEW_DATA:
                var new_license_data_temp;

                if (action.payload.field === 'hasScadenza') {
                    if (action.payload.newValue === false) {
                        new_license_data_temp = {
                            ...state.new_license_data,
                            [action.payload.field]: action.payload.newValue,
                            data_scadenza: null
                        };
                        errorText_temp.data_scadenza = '';
                    }
                    else
                        new_license_data_temp = {
                            ...state.new_license_data,
                            [action.payload.field]: action.payload.newValue,
                            data_scadenza: endOfYear(new Date())
                        };
                }
                else 
                    new_license_data_temp = {
                        ...state.new_license_data,
                        [action.payload.field]: action.payload.newValue,
                    };

                var isChanged_temp = state.isChanged;

                if (isEqual(state.license_data, new_license_data_temp)) isChanged_temp = false;
                else isChanged_temp = true;

                return {
                    ...state,
                    new_license_data: new_license_data_temp,
                    isChanged: isChanged_temp,
                    errorText: errorText_temp
                };



            case types.VALIDATE_FIELD: 

                if (action.payload.field === 'email') { 
                    if (state.new_license_data.email === '')
                        errorText_temp.email = 'Email non può essere vuota.';
                    else if (validateEmail(state.new_license_data.email)) errorText_temp.email = '';
                    else errorText_temp.email = 'Formato Email non valido.';
                }
                else if (action.payload.field === 'data_scadenza') {
                    const data_scadenza = state.new_license_data.data_scadenza;

                    if (state.new_license_data.hasScadenza === true) {

                        if (data_scadenza !== null) {

                            if (isValid(data_scadenza)) {
                                if (isBefore(data_scadenza, subDays(startOfToday(), 1))
                                    || isAfter(data_scadenza, new Date(2100, 1, 1)))
                                    errorText_temp.data_scadenza = 'Data Scadenza fuori range.';
                                else errorText_temp.data_scadenza = '';

                            } else errorText_temp.data_scadenza = 'Data Scadenza non valida.';
                        }
                        else errorText_temp.data_scadenza = 'Data Scadenza non può essere vuota se la licenza non ha scadenza.';

                    }
                } else errorText_temp.data_scadenza = '';


                var isValid_temp = false;

                // controllo se ci sono errori di validazione
                if (errorText_temp.data_scadenza === ''
                    && errorText_temp.cliente === ''
                    && errorText_temp.email === ''
                    && errorText_temp.codice_utente === '') isValid_temp = true;
                else isValid_temp = false;

                return {
                    ...state,
                    errorText: errorText_temp,
                    isValid: isValid_temp
                };

            default:
                return state;
        }
    },
    creators: ({ types }) => ({
        editLicenseRequest: (pk, new_license_data) => ({
            type: types.EDIT_LICENSE_REQUEST,
            payload: { pk, new_license_data },
        }),
        editLicenseSuccess: ({ isModified }) => ({
            type: types.EDIT_LICENSE_SUCCESS,
            payload: { isModified },
        }),
        editLicenseFailed: error => ({ type: types.EDIT_LICENSE_FAILED, error: true, payload: { error } }),

        
        handleChangeFieldNewData: (field, newValue) => ({
            type: types.HANDLE_CHANGE_FIELD_NEW_DATA,
            payload: { field, newValue },
        }),
        
        resetEditLicenseData: () => ({
            type: types.RESET_EDIT_LICENSE_STORE,
        }),
        initializeFields: (data_scadenza, cliente, email, codice_utente) => ({
            type: types.INITIALIZE_FIELDS,
            payload: { data_scadenza, cliente, email, codice_utente },
        }),
        validateField: (field) => ({
            type: types.VALIDATE_FIELD,
            payload: { field },
        }),

    }),
});
